exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.finance-order-table[data-v-5eaed8c3] {\n}\r\n", ""]);

// exports
